const config = require(`../../projects/${process.env.PROJECT}/front/configs/envs/${process.env.NODE_ENV}/config.json`)

/**
 * se è presente nell'url http o https come nel caso della configurazione del localhost
 * utilizza l'url assoluto, viceversa lo considera un url relatov e lo completa con origin
 * @param url
 * @returns {string|*}
 */
function makeAbsoluteUrl (url) {
  if (url.startsWith('http') || url.startsWith('https')) {
    return url
  }
  return window.location.origin + url
}

export const PROJECT = config.project
export const PROJECT_NAME = () => {
  const name = config.project.replaceAll('-', ' ')
  return name.charAt(0).toUpperCase() + name.slice(1)
}

export const BASE_URL = config.baseUrl
export const LATITUDE = 1 * config.latitude
export const LONGITUDE = 1 * config.longitude
export const CONFIG_WS_URL = makeAbsoluteUrl(config.wsConfigUrl)
export const WS_URL = makeAbsoluteUrl(config.wsUrl)
export const PREFIX_WS = config.prefixWs
export const GOOGLE_ANALYTICS_CODE = config.googleAnalyticsCode
export const GOOGLE_API_TOKEN = config.googleApiToken
export const IATA = config.iata
export const IATA_ARRIVO = config.iataArrivo
export const COUNTRY_ARRIVO = config.countryArrivo
export const REPARTO_ID = parseInt(config.repartoID)
export const REPARTO_NAME = config.repartoName
export const SEARCH_TOUR_LIMIT = parseInt(config.searchTourLimit)
export const SEARCH_EXPERIENCE_LIMIT = parseInt(config.searchExperienceLimit)
export const ITINERARIO_SERVICE_LIMIT = parseInt(config.itinerarioServiceLimit)
export const HOME_VIDEO = config.homeVideo
export const FAKE_ACTIVE = config.fake === 'true'
export const KEACLOAK_GROUP = config.keycloakGroup
export const FLEXY_COUNTRY = config.flexyCountry
export const FLEXY_CITY = config.flexyCity
export const SITE_SOURCE = config.siteSource
export const FLEXY_REPARTO = config.flexyReparto
export const META_THUMBNAIL = config.metaThumbnail
export const META_DESCRIPTION = config.metaDescription
export const META_KEYWORDS = config.metaKeywords
export const META_AUTHOR = config.metaAuthor
export const META_COPYRIGHT = config.metaCopyright
export const META_OG_TITLE = config.metaOgTitle
export const META_OG_IMAGE = config.metaOgImage
export const META_OG_TYPE = config.metaOgType
export const META_OG_DESCRIPTION = config.metaOgDescription
export const META_OG_URL = config.metaOgUrl
export const FB_DOMAIN_VERIFICATION = config.metaFbDomainVerification
export const FB_PIXEL_TAG = config.fbPixelTag
export const IUBENDA_CONFIG = config.iubenda



// WEBPACK FOOTER //
// ./src/front/utils/config.js